import React, {useEffect, useState} from 'react';
import {
    Button,
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxOption,
    ComboboxOptions,
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
    Field,
    Input,
    Label,
    Select,
    Switch,
    Textarea
} from "@headlessui/react";
import {
    ArrowLeftIcon,
    ArrowPathIcon,
    BanknotesIcon,
    CheckBadgeIcon,
    CheckIcon,
    ChevronDoubleRightIcon, ClipboardDocumentListIcon,
    CreditCardIcon,
    ExclamationTriangleIcon,
    EyeSlashIcon,
    InformationCircleIcon,
    LockClosedIcon,
    MagnifyingGlassIcon,
    PaperAirplaneIcon,
    PencilIcon,
    PhoneIcon,
    PlusIcon,
    SquaresPlusIcon,
} from "@heroicons/react/24/outline";
import ProductInput from "./ProductInput";
import BulkProductConfirmation, { getBulkProducts, bulkConfirmationKey } from "./BulkProductConfirmation";
import {db} from "../../firebase/firebase";
import {useAuth} from "../../contexts/authContext";
import {useDarkMode} from "../../contexts/darkModeContext";

import createQuoteTemplate from "./QuoteTemplate";

import pdfMake from "pdfmake/build/pdfmake";
import {collection, doc, getDoc, getDocs, updateDoc} from "firebase/firestore";
import {ChevronUpDownIcon, SlashIcon} from "@heroicons/react/16/solid";
import Loading from "../Widgets/Loading";
import FireworksEffect from "../Widgets/FireworksEffect";
import {categoryColors, getCategoryInfo, numberWithCommas, pricingMapping} from "../GLOBAL/GlobalFunctions";
import pdfIcon from "../../pdfIcon.png";
import createQuoteTemplateBlank from "./QuoteTemplateBlank";
import {useNotification} from "../Notifications/NotificationProvider";

import {ReactComponent as LIME} from "../../customIcons/LIME.svg";
import {calculateDiscountedTotal, parsedDiscount} from "./OrderFunctions";

import PFC46 from "../../PFC_Images/PFC46.png";
import ActionPillButton from "../Widgets/ActionPillButton";
import ShortOrderFreight from "./ShortOrderFreight";
import StepperInput from "./StepperInput";


const NewOrder = ({ isEditing, order, close }) => {
    const { currentUser } = useAuth();
    
    const { darkMode } = useDarkMode();
    const { triggerNotification } = useNotification();
    
    const getNextBusinessDate = (daysOut) => {
        let date = new Date();
        let count = 0;
    
        while (count < daysOut) {
            date.setDate(date.getDate() + 1);
            // Check if the day is not Saturday (6) or Sunday (0)
            if (date.getDay() !== 0 && date.getDay() !== 6) {
                count++;
            }
        }
        return date.toISOString().split('T')[0]; // Format as YYYY-MM-DD for input value
    };
    
    const [alertsOn] = useState(() => {
        const storedSettings = localStorage.getItem('alertsOn');
        return storedSettings ? JSON.parse(storedSettings).alertsOn : false; // Default to false if null
    });
    
    const [showFireworks, setShowFireworks] = useState(false)
    
    const [estimatedFreight, setEstimatedFreight] = useState(0);
    
    // eslint-disable-next-line
    const [date] = useState(new Date().toLocaleDateString());
    const [deliveryDate, setDeliveryDate] = useState(order?.deliveryDate || getNextBusinessDate(5));

    const [callBefore, setCallBefore] = useState(order?.callBefore || false);
    const [earlyOrder, setEarlyOrder] = useState(order?.earlyOrder || false);
    const [prePay, setPrePay] = useState(order?.prePay || false);
    const [ASAP, setASAP] = useState(order?.asap || false);
    const [consumePre, setConsumePre] = useState(order?.consumePre || false);
    
    const [prePayAlert, setPrePayAlert] = useState(false);
    const [EODAlert, setEODAlert] = useState(false);

    const [notes, setNotes] = useState(order?.notes || "");
    const [poNum, setPoNum] = useState(order?.poNum || "");
    
    const [fullname, setFullname] = useState(order?.salesRep || "");
    const [salesCode, setSalesCode] = useState(order?.salesCode || "");
    const [salesEmail, setSalesEmail] = useState(order?.salesEmail || "");
    const [accountLevel, setAccountLevel] = useState("");
    
    const [customerCode, setCustomerCode] = useState(order?.customerCode || "");
    
    
    const [customerType, setCustomerType] = useState(  order?.discount || 0);
    const [initialCustomerType, setInitalCustomerType] = useState(  order?.discount || 0);
    const [isBulk, setIsBulk] = useState(order?.isBulk || false);
    
    
    const [customerPhone, setCustomerPhone] = useState( "");
    const [customerUID, setCustomerUID] = useState("");
    const [contractPrices, setContractPrices] = useState([]);
    const [address, setAddress] = useState("");
    const [shippingLocations, setShippingLocations] = useState([]);
    const [tankLocations, setTankLocations] = useState([]);
    const [industry, setIndustry] = useState(order?.customerIndustry || "");
    const [customers, setCustomers] = useState([]);
    const [priceType, setPriceType] = useState(order?.priceType || "");
    const [discount, setDiscount] = useState( 0);
    
    const [state, setState] = useState( order?.state || "" );

    const [totals, setTotals] = useState([]);
    const [discounTotals, setDiscountTotals] = useState([]);

    const [productInputs, setProductInputs] = useState(order?.products || []);
    
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);


    const [finalProducts, setFinalProducts] = useState([]);
    const [confirmedBulkKey, setConfirmedBulkKey] = useState(null);
    const bulkProducts = getBulkProducts(finalProducts);
    const bulkKey = bulkConfirmationKey(bulkProducts);
    const bulkConfirmed = bulkProducts.length === 0 || confirmedBulkKey === bulkKey;

    useEffect(() => {
        setConfirmedBulkKey(null);
    }, [bulkKey]);
    
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [BulkOrder, setBulkOrder] = useState(false);

    const [quoteToolTip, setQuoteToolTip] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [showProducts, setShowProducts] = useState(false); // To control product list visibility

    const [browse, setBrowse] = useState(false);

    const toggleVisibility = () => {
        setBrowse(!browse);
    };
    
    const [open, setOpen] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isPlanned, setIsPlanned] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isNoPhone, setIsNoPhone] = useState(false);

    const toggleSubmitting = () => {
        setConfirmedBulkKey(null);
        setIsSubmitting(!isSubmitting);
    };
    
    const togglePlanned = () => {
        setConfirmedBulkKey(null);
        setIsPlanned(!isPlanned);
    }
    
    const toggleUpdating = () => {
        setIsUpdating(!isUpdating);
    }
    
    
    useEffect(() => {
        const fetchUserName = async () => {
            if (currentUser) {
                try {
                    // Check if user data is in localStorage
                    const storedUserData = localStorage.getItem(`userData_${currentUser.uid}`);

                    if (storedUserData) {
                        // Use the stored user data
                        const userData = JSON.parse(storedUserData);
                        setSalesCode(userData.salesCode);
                        setFullname(userData.fname + " " + userData.lname);
                        setSalesEmail(userData.email);
                        setAccountLevel(userData.accountLevel);
                        // setRegion(userData.region || "");

                    } else {
                        // Fetch user document from Firestore based on the current user's UID
                        const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                        if (userDoc.exists) {
                            // Get the user's name from the document data
                            const userData = userDoc.data();
                            setSalesCode(userData.salesCode);
                            setSalesEmail(userData.email);
                            setAccountLevel(userData.accountLevel);
                            // setRegion(userData.region || "");

                            // Save user data to localStorage
                            localStorage.setItem(`userData_${currentUser.uid}`, JSON.stringify(userData));
                        } else {
                            console.log('User document not found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };
        
        const fetchCustomers = async () => {
            if (currentUser) {
                try {
                    // Reference the current user's document
                    const userDocRef = doc(db, "Users", currentUser.uid);
                    const userDocSnap = await getDoc(userDocRef);
        
                    if (userDocSnap.exists()) {
                        const userData = userDocSnap.data();
                        const { customersUpdated } = userData;
        
                        if (customersUpdated) {
                            // Fetch fresh data from Firestore
                            console.log("Fetching customers from Firestore...");
                            const clientsCollection = collection(db, "Customers", currentUser.uid, "clients");
                            const snapshot = await getDocs(clientsCollection);
        
                            if (!snapshot.empty) {
                                const customersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                                setCustomers(customersData);
                                localStorage.setItem(`activeCustomers_${currentUser.uid}`, JSON.stringify(customersData));
        
                                // Reset the update flag in Firestore
                                await updateDoc(userDocRef, { customersUpdated: false });
                                console.log("Set customersUpdated to false after fetching.");
                            } else {
                                console.log("No customers found in Firestore.");
                            }
                        } else {
                            // Load from localStorage
                            console.log("Loading customers from localStorage...");
                            const storedData = localStorage.getItem(`activeCustomers_${currentUser.uid}`);
                            if (storedData) {
                                const customersData = JSON.parse(storedData);
                                setCustomers(customersData);
                            } else {
                                console.log("No customers found in localStorage.");
                            }
                        }
                    } else {
                        console.log("User document does not exist.");
                    }
                } catch (error) {
                    console.error("Error fetching customers data:", error);
                }
            }
        };
        
        const fetchAllUsersActiveData = async () => {
            
             // User Data
            try {
    
                // Fetch user document from Firestore based on the current user's UID
                const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                if (userDoc.exists) {
                    // Get the user's name from the document data
                    const userData = userDoc.data();
                    setReps(userData.reps);
    
                    // Save user data to localStorage
                    localStorage.setItem(`userData_${currentUser.uid}`, JSON.stringify(userData));
                } else {
                    console.log('User document not found');
                }
    
            } catch (error) {
                console.error("Error fetching all pending orders", error);
            }
            
            try {

                // Check if reps is null or empty
                if (!reps || reps.length === 0) {
                    console.log("Reps is null or empty. Returning an empty array.");
                    setCustomers([]);
                    return;
                }

                const storedAllData = localStorage.getItem(`allCustomers_${currentUser.uid}`);
                if (storedAllData) {
                    const allData = JSON.parse(storedAllData);
                    setCustomers(allData);
                } else {
                    // Extract user IDs from the reps array
                    const repsIds = reps.map((rep) => rep.id);

                    let allClientsData = [];

                    // Iterate over the allowed user IDs in repsIds
                    const userPromises = repsIds.map(async (userId) => {
                        // Reference to the client's collection for this user
                        const clientsCollectionRef = collection(db, `Customers/${userId}/clients`);
                        const clientsSnapshot = await getDocs(clientsCollectionRef);

                        // Push client data to the allClientsData array
                        clientsSnapshot.forEach((clientDoc) => {
                            allClientsData.push({
                                ...clientDoc.data(),
                                id: clientDoc.id, // Add document ID
                                salesID: userId, // ADD USER ID
                            });
                        });
                    });

                    // Run all user-level fetches in parallel
                    await Promise.all(userPromises);

                    // Handle empty data scenario
                    if (allClientsData.length > 0) {
                        setCustomers(allClientsData);
                        localStorage.setItem(`allCustomers_${currentUser.uid}`, JSON.stringify(allClientsData));
                    } else {
                        // Clear the state and localStorage when no data is found
                        setCustomers([]);
                        localStorage.removeItem(`allCustomers_${currentUser.uid}`);
                        console.log('No clients found, clearing data.');
                    }
                }
            } catch (error) {
                console.error("Error fetching clients data for all users: ", error);
            }
        };
        
        if (!isEditing) {
            fetchUserName();
        }
        
        if (accountLevel === "CSR" || accountLevel === "A"){
            fetchAllUsersActiveData();
        } else {
            fetchCustomers();
        }
        
        // eslint-disable-next-line
    }, [currentUser, isEditing]);

    
    const filterProductsByAccountLevel = (products, accountLevel) => {
        if (accountLevel === "DIST") {
            return products.filter(product =>
                Array.isArray(product.prices) &&
                product.prices.some(price => price.dist1 && price.dist1 !== "")
            );
        }
    
        return products; // no filtering for other account levels
    };



    useEffect(() => {
        const fetchProducts = async () => {
            if (currentUser) {
                try {
                    // Fetch the 'productUpdated' field for the current user
                    const userDocRef = doc(db, "Users", currentUser.uid);
                    const userDocSnap = await getDoc(userDocRef);

                    if (userDocSnap.exists()) {
                        const userData = userDocSnap.data();
                        const { productUpdated } = userData;

                        if (productUpdated) {
                            // If 'productUpdated' is true, fetch products from Firestore
                            // console.log("Fetching products from Firestore...");
                            const productsCollection = collection(db, "Products");
                            const snapshot = await getDocs(productsCollection);

                            if (!snapshot.empty) {
                                const productData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                                
                                const filtered = filterProductsByAccountLevel(productData, accountLevel);

                                setProducts(filtered);
                                setFilteredProducts(filtered);
                                localStorage.setItem(`products_${currentUser.uid}`, JSON.stringify(filtered));
                                
                                
                                // setProducts(productData);
                                // setFilteredProducts(productData);
                                // localStorage.setItem(`products_${currentUser.uid}`, JSON.stringify(productData));

                                
                                
                                // Set 'productUpdated' to false
                                await updateDoc(userDocRef, { productUpdated: false });
                                console.log("Set productUpdated to false after fetching from Firestore.");
                            } else {
                                console.log("No products found in Firestore.");
                            }
                        } else {
                            // If 'productUpdated' is false, load products from localStorage
                            console.log("Loading products from localStorage...");
                            const storedProducts = localStorage.getItem(`products_${currentUser.uid}`);
                            if (storedProducts) {
                                const storedData = JSON.parse(storedProducts);
                                
                                // setProducts(storedData);
                                // setFilteredProducts(storedData);
                                
                                const filtered = filterProductsByAccountLevel(storedData, accountLevel);

                                setProducts(filtered);
                                setFilteredProducts(filtered);
                                localStorage.setItem(`products_${currentUser.uid}`, JSON.stringify(filtered));
                                
                                
                            } else {
                                console.log("No products found in localStorage.");
                            }
                        }
                    } else {
                        console.log("User document does not exist.");
                    }
                } catch (error) {
                    console.error("Error fetching product data:", error);
                }
            }
        };
        
        fetchProducts();
        
    }, [currentUser, accountLevel]);
    
    
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
    
        if (value) {
            setFilteredProducts(
                products.filter((product) =>
                    product.name.toLowerCase().includes(value) ||
                    product.prices.some((price) => price.code.toLowerCase().includes(value))
                )
            );
            setShowProducts(true); // Show the product list while typing
        } else {
            setShowProducts(false); // Hide the product list if the search bar is empty
        }
    };
    
    const generateUniqueKey = () => {
        return `key-${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
    };
    
    const addProductInput = (product = null) => {
        const newKey = generateUniqueKey();
    
        const productWithKey = product
            ? { ...product, key: newKey }
            : {
                  id: `temp-${newKey}`,
                  blank: true,
                  key: newKey,
              };
        
        // Set global variable if BULK exists
        if (product && product.BULK) {
            setBulkOrder(true);
        }
    
        setProductInputs((prevInputs) => [...prevInputs, productWithKey]);
        
        setSearchTerm('');
        setShowProducts(false);
    };
    
   
    const handleRemoveProduct = (uniqueKey) => {
        setProductInputs(prevInputs => {
            const matchedItem = prevInputs.find(item => item.key === uniqueKey || item.uniqueKey === uniqueKey);
            if (!matchedItem) return prevInputs;
            
            // Also remove from finalProducts
            setFinalProducts(prevFinals =>
                prevFinals.filter(item => item.key !== uniqueKey && item.uniqueKey !== uniqueKey)
            );
    
            // Finally return new productInputs without the matched item
            return prevInputs.filter(item =>
                item.key !== uniqueKey && item.uniqueKey !== uniqueKey
            );
        });
    };
    
    // Calculate grand total
    const [subTotal, setSubTotal] = useState(0);
    const [actualTotal, setActualTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);

    
    useEffect(() => {

        const calculateTotalSum = (finalProducts) => {
            if (!Array.isArray(finalProducts) || finalProducts.length === 0) {
                console.log('total');
                return 0; // Return 0 if the array is empty or not valid
            }

            return finalProducts.reduce((sum, product) => {
                // Check if the product has a valid 'total' value and add it to the sum
                console.log('total');
                return sum + (product.total ? parseFloat(product.total) : 0);
            }, 0);
        };

        const calculateTotalSumSub = (finalProducts) => {
            if (!Array.isArray(finalProducts) || finalProducts.length === 0) {
                console.log('total');
                return 0; // Return 0 if the array is empty or not valid
            }

            return finalProducts.reduce((sum, product) => {
                console.log('total');
                // Check if the product has a valid 'total' value and add it to the sum
                return sum + (product.actualTotal ? parseFloat(product.actualTotal) : 0);
            }, 0);
        };

        const totalActual = calculateTotalSum(finalProducts);
        const totalSubTotal = calculateTotalSumSub(finalProducts);

        setActualTotal(totalActual)
        setSubTotal(totalSubTotal);
    }, [totals, discounTotals, finalProducts, customerType, earlyOrder]);

    useEffect(() =>{

        let disc = (subTotal - actualTotal).toFixed(2)

        setDiscount(disc);
        setGrandTotal(actualTotal)

        console.log(finalProducts);

        console.log('discounts');

            // eslint-disable-next-line
    },[priceType, subTotal, actualTotal, discount, customerCode, customerType, earlyOrder]);
    
    const [reps, setReps] = useState([]);
    

    const [updating, setUpdating] = useState(false);
    

    const onUpdate = async () => {
        setUpdating(true);
        const startTime = Date.now();

        // Products
        try {
            const productsCollection = db.collection("Products");
            const snapshot = await productsCollection.get();

            if (!snapshot.empty) {
                const productData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
               
               
                // setProducts(productData);
                // setFilteredProducts(productData);
                // localStorage.setItem(`products_${currentUser.uid}`, JSON.stringify(productData));
            
                const filtered = filterProductsByAccountLevel(productData, accountLevel);

                setProducts(filtered);
                setFilteredProducts(filtered);
                localStorage.setItem(`products_${currentUser.uid}`, JSON.stringify(filtered));
                
            
            } else {
                console.log('Product documents not found');
            }

        } catch (error) {
            console.error("Error updating products", error);
        }

        const endTime = Date.now();
        const timeElapsed = (endTime - startTime) /1000;
        setUpdating(false);
        
        if (alertsOn) {
            alert(`Products Updated in ${timeElapsed} secs`);
        }
        triggerNotification("productUpdateSuccess");
    };
    
    const onUpdateCustomer = async () => {
        setUpdating(true);
        const startTime = Date.now();
        
        // Active
        try {
            console.log("Updating Active");
            
            const customers = db.collection("Customers").doc(currentUser.uid).collection("clients");
            const snapshot = await customers.get();

            if (!snapshot.empty) {
                const activeData = snapshot.docs.map(doc => ({ id: doc.id, salesID: currentUser.uid, ...doc.data() }));
                setCustomers(activeData);
                localStorage.setItem(`activeCustomers_${currentUser.uid}`, JSON.stringify(activeData));
            } else {
                setCustomers([]);
                localStorage.setItem(`activeCustomers_${currentUser.uid}`, JSON.stringify([]));
                console.log('Customer document not found');
            }

        } catch (error) {
            console.error("Error updating customers", error);
        }
        
        console.log("finished Updating");
        
        const endTime = Date.now();
        const timeElapsed = (endTime - startTime) / 1000;
        setUpdating(false);
        
        if (alertsOn) {
            alert(`Customers Updated in ${timeElapsed} secs`);
        }
        triggerNotification("customerUpdateSuccess");

    };
    
    const onUpdateCSR = async () => {
        setUpdating(true);
        const startTime = Date.now();

        // User Data
        try {

            // Fetch user document from Firestore based on the current user's UID
            const userDoc = await db.collection('Users').doc(currentUser.uid).get();
            if (userDoc.exists) {
                // Get the user's name from the document data
                const userData = userDoc.data();
                setReps(userData.reps);

                // Save user data to localStorage
                localStorage.setItem(`userData_${currentUser.uid}`, JSON.stringify(userData));
            } else {
                console.log('User document not found');
            }

        } catch (error) {
            console.error("Error fetching all pending orders", error);
        }
        
        // Active
        try {
            // Extract user IDs from the reps array
            const repsIds = reps.map((rep) => rep.id);

            let allClientsData = [];

            // Iterate over the allowed user IDs in repsIds
            const userPromises = repsIds.map(async (userId) => {
                // Reference to the client's collection for this user
                const clientsCollectionRef = collection(db, `Customers/${userId}/clients`);
                const clientsSnapshot = await getDocs(clientsCollectionRef);

                // Push client data to the allClientsData array
                clientsSnapshot.forEach((clientDoc) => {
                    allClientsData.push({
                        ...clientDoc.data(),
                        id: clientDoc.id, // Add document ID
                        salesID: userId, // ADD USER ID
                    });
                });
            });

            // Run all user-level fetches in parallel
            await Promise.all(userPromises);

            // Handle empty data scenario
            if (allClientsData.length > 0) {
                setCustomers(allClientsData);
                localStorage.setItem(`allCustomers_${currentUser.uid}`, JSON.stringify(allClientsData));
            } else {
                // Clear the state and localStorage when no data is found
                setCustomers([]);
                localStorage.removeItem(`allCustomers_${currentUser.uid}`);
                console.log('No clients found, clearing data.');
            }

        } catch (error) {
            console.error("Error fetching active data for all users: ", error);
        }
        

        const endTime = Date.now();
        const timeElapsed = (endTime - startTime) /1000;
        setUpdating(false);
        
        triggerNotification("allCustUpdated");
        
        if (alertsOn) {
            alert(`Orders Updated in ${timeElapsed} secs`)
        }
    };



    
    const handleSelectChange = (customer) => {
        if (customer) {
            // Set selected customer and related fields
            setSelectedCustomer(customer);
            setIndustry(customer.industry);
            setPriceType(customer.priceType);
            setCustomerCode(customer.customerCode);
            setCustomerPhone(customer.contactPhone);
            
            const { discount, isBulk } = parsedDiscount(customer.customerType || "");
            
            setCustomerType(discount || 0);
            setInitalCustomerType(discount || 0);
            setIsBulk(isBulk || false);
            
            
            
            setCustomerUID(customer.id);
    
            const shippingAddresses = customer.ShippingAddresses || [];
            setShippingLocations(shippingAddresses);
    
            setTankLocations(customer.tankLocations || []);
            setContractPrices(customer.contractPrices || []);
            setState(customer.state);
    
            // Default to first shipping address if available
            if (shippingAddresses.length > 0) {
                const addr = shippingAddresses[0];
                setAddress(`${addr.address1} ${addr.city}, ${addr.state} ${addr.zip}`);
            } else {
                // fallback to original customer address
                setAddress(`${customer.address1} ${customer.city}, ${customer.state} ${customer.zip}`);
            }
        } else {
            // Reset fields if no customer is selected
            setSelectedCustomer(null);
            setIndustry("");
            setPriceType("");
            setCustomerCode("");
            setCustomerPhone("");
            setCustomerType(0);
            setInitalCustomerType(0);
            setCustomerUID("");
            setShippingLocations([]);
            setTankLocations([]);
            setContractPrices([]);
            setAddress("");
            setState([]);
        }
        setQuery('');
    };

    // Function to handle adding a product's data
    const handleAddFinalProduct = (index, productData) => {
        setFinalProducts(prevProducts => {
            const updatedProducts = [...prevProducts];
            updatedProducts[index] = productData; // Add or update the product data at the correct index
            return updatedProducts;
        });
    };



    const onSubmitPlanned = async () => {
        if (!addressConfirm || !bulkConfirmed) return;
        const collectionRef = db.collection("Customers").doc(currentUser.uid).collection("clients").doc(customerUID).collection("planned");
        const parsedFormData = {

            // Sales Info
            salesRep: fullname,
            salesCode: salesCode,
            status: "planned",
            salesEmail: salesEmail,
            salesUID: currentUser.uid,
            
            poNum: poNum,

            orderDate: "",
            customerCode: customerCode,
            customerIndustry: industry  || "",
            customerName: selectedCustomer.name,
            customerPhone: customerPhone || "",
            customerEmail: selectedCustomer.contactEmail || "",
            customerUID: customerUID || "",
            address: address,
            priceType: priceType,
            
            contactPhone: customerPhone || "",
            contact: selectedCustomer.contact || "",
            billingContact: selectedCustomer.billingContact || "",
            billingPhone: selectedCustomer.billingPhone || "",

            products: finalProducts,
            BulkOrder: BulkOrder,
            state: state,

            notes: notes,
            deliveryDate: deliveryDate,
            callBefore: callBefore,
            earlyOrder: earlyOrder,
            prePay: prePay,
            consumePre: consumePre,
            asap: ASAP,

            grandTotal: parseFloat(calculateDiscountedTotal(state, grandTotal, earlyOrder, prePay)),
            // grandTotal: parseFloat(grandTotal),
            discountTotal: parseFloat(discount),
            discount: parseFloat(customerType),
            isBulk: isBulk || false,
            subTotal: parseFloat(subTotal),
            
            estimatedFreight: estimatedFreight || 0,

        };
        
        console.log("Final Products", finalProducts);

        try {
            await collectionRef.add(parsedFormData);
            
            localStorage.setItem('newOrder', 'true');
            if (alertsOn) {
                alert(`Order Saved as Planned`); // Optional: alert for user feedback
            }
            
            setIsPlanned(false);
            
            setShowFireworks(true);
            triggerNotification("plannedSuccess");
            
            setTimeout(() => setShowFireworks(false), 5000) // Hide fireworks after 3 seconds
            
            await clear();

        } catch (error) {
            triggerNotification("plannedError");
            console.error('Error registering client:', error.message);
        }
    };

    const onSubmitPending = async () => {
        if (!addressConfirm || !bulkConfirmed) return;

        const collectionRef = db.collection("Customers").doc(currentUser.uid).collection("clients").doc(customerUID).collection("pending");

        const parsedFormData = {

            // Sales Info
            salesRep: fullname,
            salesCode: salesCode,
            status: "pending",
            salesEmail: salesEmail,
            salesUID: currentUser.uid,
            
            poNum: poNum,

            orderDate: date,
            customerCode: customerCode,
            customerIndustry: industry || "",
            customerName: selectedCustomer.name || "",
            customerPhone: customerPhone || "",
            customerEmail: selectedCustomer.contactEmail || "",
            customerUID: customerUID || "",
            address: address,
            priceType: priceType,

            contactPhone: customerPhone || "",
            contact: selectedCustomer.contact || "",
            billingContact: selectedCustomer.billingContact || "",
            billingPhone: selectedCustomer.billingPhone || "",

            products: finalProducts,
            BulkOrder: BulkOrder,
            state: state,

            submittedTime: Date.now(),

            notes: notes,
            deliveryDate: deliveryDate,
            callBefore: callBefore,
            earlyOrder: earlyOrder,
            prePay: prePay,
            consumePre: consumePre,
            asap: ASAP,

            grandTotal: parseFloat(calculateDiscountedTotal(state, grandTotal, earlyOrder, prePay)),
            // grandTotal: parseFloat(grandTotal),
            discountTotal: parseFloat(discount),
            discount: parseFloat(customerType),
            isBulk: isBulk || false,
            subTotal: parseFloat(subTotal),
            
            estimatedFreight: estimatedFreight || 0,

        };

        try {
            await collectionRef.add(parsedFormData);

            localStorage.setItem('newOrder', 'true');

            if (alertsOn) {
                alert(`Order Saved as Pending`);
            }
            setIsSubmitting(false);

            setShowFireworks(true);
            triggerNotification("pendingSuccess");
            
            setTimeout(() => setShowFireworks(false), 5000) // Hide fireworks after 3 seconds

            await clear();
            

        } catch (error) {
            console.error('Error registering client:', error.message);
            triggerNotification("pendingError");
        }
    };
    
    const [errorUpdate, setErrorUpdate] = useState(false);
    
    const onSubmittingUpdating = async () => {
        if (!order?.id) {
            console.error("No order ID provided for editing.");
            return;
        }
    
        console.log("Sales ID:", order?.salesUID);
        console.log("Customer ID:", order?.customerUID);
        console.log("Order ID:", order?.id);
        console.log("Status:", order?.status);
    
        const orderRef = db.collection("Customers")
            .doc(order?.salesUID)
            .collection("clients")
            .doc(order?.customerUID)
            .collection(order?.status)
            .doc(order?.id);
    
        try {
            const orderSnapshot = await orderRef.get();
    
            if (!orderSnapshot.exists) {
                console.error("Order does not exist.");
                return;
            }
    
            const orderData = orderSnapshot.data();
            const updatedOrderData = {
                ...orderData,
                // status: "pending",
                salesRep: fullname || "",
                salesCode: salesCode || "",
                salesEmail: salesEmail || "",
                
                products: finalProducts || [],
                BulkOrder: BulkOrder,
                
                notes: notes || "",
                
                deliveryDate: deliveryDate || "",
                callBefore: callBefore || false,
                earlyOrder: earlyOrder || false,
                prePay: prePay || false,
                consumePre: consumePre || false,
                asap: ASAP || false,
                
                grandTotal: parseFloat(calculateDiscountedTotal(state, grandTotal, earlyOrder, prePay)) || 0,
                // grandTotal: parseFloat(grandTotal) || 0,
                discountTotal: parseFloat(discount) || 0,
                discount: parseFloat(customerType) || 0,
                isBulk: isBulk || false,
                subTotal: parseFloat(subTotal) || 0,
                
                estimatedFreight: estimatedFreight || 0,
            };
    
            await orderRef.set(updatedOrderData, { merge: true });
    
            localStorage.setItem("newOrder", "true");
    
            if (alertsOn) {
                alert("Order Updated Successfully");
            }
    
            console.log("Order Updated Successfully!");
            
            setIsUpdating(false);
            setShowFireworks(true);
            setTimeout(() => setShowFireworks(false), 5000); // Hide fireworks after 5 seconds
    
            close();
        } catch (error) {
            console.error("Error updating order:", error.message);
            setErrorUpdate(true);
        }
    };
    
    
    
    const clear = async () => {
        setProductInputs([]);
        setTotals([]);
        setFinalProducts([]);
        setCustomerCode("");
        setIndustry("");
        setPriceType("");
        setDeliveryDate(getNextBusinessDate(5))
        setSelectedCustomer(null);
        setDiscount(0);
        setGrandTotal(0);
        setActualTotal(0);
        setSubTotal(0);
        setDiscountTotals([]);
        setCustomerType(0);
        setInitalCustomerType(0);
        setEarlyOrder(false);
        setCallBefore(false);
        setPrePay(false);
        setConsumePre(false)
        setASAP(false);
        setNotes("");
        setAddress("");
        setShippingLocations([]);
        setTankLocations([]);
        setContractPrices([]);
        setCustomerPhone("");
        setAddressConfirm(false);
        setPoNum("");
        setBulkOrder(false);
        setState("");
        
        triggerNotification("newOrderCleared");
    }
    
    
    const downloadQuotePDF = async () => {
        const hasCustomer = selectedCustomer && selectedCustomer.name;
    
        const data = {
            salesRep: fullname,
            salesCode: salesCode,
            status: "planned",
            salesEmail: salesEmail,
            salesUID: currentUser.uid,
    
            orderDate: "",
            customerCode: customerCode,
            customerIndustry: hasCustomer ? industry || "" : "",
            customerName: hasCustomer ? selectedCustomer.name : "Unassigned Customer",
            customerPhone: hasCustomer ? customerPhone || "" : "",
            customerEmail: hasCustomer ? selectedCustomer.contactEmail || "" : "",
            customerUID: hasCustomer ? customerUID || "" : "",
            address: hasCustomer ? address : "No address provided",
            priceType: priceType,
            
            contactPhone: hasCustomer ? customerPhone || "" : "",
            contact: hasCustomer ? selectedCustomer.contact || "" : "",
            billingContact: hasCustomer ? selectedCustomer.billingContact || "" : "",
            billingPhone: hasCustomer ? selectedCustomer.billingPhone || "" : "",
    
            products: finalProducts,
            BulkOrder: BulkOrder,
    
            submittedTime: Date.now(),
    
            notes: notes,
            deliveryDate: deliveryDate,
            callBefore: callBefore,
            earlyOrder: earlyOrder,
            prePay: prePay,
            consumePre: consumePre,
            state: state,
    
            // grandTotal: parseFloat(grandTotal),
            grandTotal: parseFloat(calculateDiscountedTotal(state, grandTotal, earlyOrder, prePay)),
            discountTotal: parseFloat(discount),
            discount: parseFloat(customerType),
            isBulk: isBulk || false,
            subTotal: parseFloat(subTotal),
            
            estimatedFreight: estimatedFreight,
        };
    
        const docDefinition = hasCustomer
            ? createQuoteTemplate(data)
            : createQuoteTemplateBlank(data);
    
        const fileName = hasCustomer ? `${customerCode}_quote.pdf` : `${priceType}_blanket_quote.pdf`;
    
        pdfMake.createPdf(docDefinition).download(fileName);
    };
    

    const [query, setQuery] = useState('')

    const filteredCustomers =
        query === ''
            ? customers
            : customers.filter((customer) => {
                return (
                    customer.name.toLowerCase().includes(query.toLowerCase()) ||
                    (customer.customerCode?.toLowerCase()?.includes(query.toLowerCase()) ?? false)
                );
            });
    
    const [isToday, setIsToday] = useState(false);

    const handleDeliveryDateChange = (e) => {
        const selectedDate = e.target.value;
        setDeliveryDate(selectedDate);
    
        // Check if selected date matches today's date
        if (selectedDate === new Date().toISOString().split('T')[0]) {
            setIsToday(true);
        } else {
            setIsToday(false);
        }
    };
    
    
    useEffect(() =>{
        
        if (callBefore && selectedCustomer && !customerPhone) {
            setIsNoPhone(true);
        }
        
        console.log('No Phone');
      // eslint-disable-next-line
    },[callBefore, selectedCustomer]);
    
    const [addressConfirm, setAddressConfirm] = useState(false);
    
    return (
        <div className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'}  h-[calc(100dvh-3.5rem)] flex w-full transition-all duration-500 ease-in-out`}>

            {updating && (
                <Loading/>
            )}
            
            {showFireworks && <FireworksEffect show={showFireworks} />}
            
            
            
            {/*ORDER FORM*/}
            <div className="z-20 flex flex-col h-full w-full">
                
                {/*ORDER FORM BODY [Order Info]*/}
                <div className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} grid grid-cols-4 animate-slideInRight w-full overflow-y-scroll scrollbar-hide transition-all duration-500 ease-in-out`}>

                    {/*CUSTOMER DETAILS*/}
                    <div className={`bg-gray-700/10 border-b ${darkMode ? 'border-neutral-700' : ''} col-span-full grid grid-cols-6 p-1 animate-fadeIn w-full h-fit ${darkMode ? 'text-white' : 'text-black'}`}>
                        
                        {/*CUSTOMER*/}
                        <div className="col-span-3 flex flex-row items-center">
                            
                            <div className={`w-full m-1.5 flex items-center rounded-md border ${darkMode ? 'border-neutral-700 bg-darkMainColor' : 'bg-white'} px-2 `}>
                               
                                <div className={`w-full`}>
                                    <Combobox
                                        as="div"
                                        value={selectedCustomer}
                                        onChange={handleSelectChange} // Use the updated handler
                                    >
                                        <div className="relative w-full">
                                            <ComboboxInput
                                                className={`block w-full grow bg-transparent py-2 pr-3 pl-1 text-base placeholder:text-gray-400 focus:outline-none sm:text-sm/6`}
                                                onChange={(event) => setQuery(event.target.value)}
                                                onBlur={() => setQuery('')}
                                                disabled={isEditing}
                                                placeholder={`Select or enter a customer from your list of ${customers.length} available customers`}
                                                displayValue={(customer) => customer?.name || order?.customerName || ""}
                                            />
                                            <ComboboxButton disabled={isEditing}
                                                            className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2">
                                                <ChevronUpDownIcon className="size-5 text-gray-400" aria-hidden="true"/>
                                            </ComboboxButton>
                                            
                                            <ComboboxOptions
                                                className={`absolute z-10 mt-1 max-h-96 animate-fadeIn focus:outline-none  w-full overflow-auto rounded-2xl ${darkMode ? 'bg-neutral-800' : 'bg-white'} py-1 text-base shadow-lg sm:text-sm`}>
                                                {Array.isArray(filteredCustomers) && filteredCustomers.length > 0 ? (
                                                    filteredCustomers.map((customer) => (
                                                        <ComboboxOption
                                                            key={customer.id}
                                                            value={customer} // Pass the whole customer object as the value
                                                            className={`group relative rounded-full focus:outline-none cursor-default select-none py-2 pl-3 pr-9 ${
                                                                darkMode
                                                                    ? 'data-[focus]:bg-darkMainColor data-[focus]:bg-opacity-50'
                                                                    : 'data-[focus]:bg-neutral-200'
                                                            }`}
                                                        >
                                                            <div className="flex items-center">
                                                                <div
                                                                    className={`rounded-full py-0.5 px-2 ${darkMode ? 'bg-neutral-600' : 'bg-bgColor'}`}>
                                                                    {customer.customerCode}
                                                                </div>
                                                                <span
                                                                    className="ml-3 truncate group-data-[selected]:font-semibold">{customer.name}</span>
                                                            </div>
                                                            
                                                            <span
                                                                className="absolute inset-y-0 right-0 hidden items-center pr-4 text-green-600-600 group-data-[selected]:flex group-data-[focus]:text-white">
                                                                <CheckIcon className="size-5" aria-hidden="true"/>
                                                            </span>
                                                        </ComboboxOption>
                                                    ))
                                                ) : (
                                                    <div className={`flex items-center justify-center flex-col p-3`}>
                                                        <EyeSlashIcon className={`w-6 stroke-2 opacity-50`}/>
                                                        <div className="px-4 py-2 text-sm opacity-50">
                                                            No customer found for <span
                                                            className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}>'{query}'</span>.
                                                            Please try again.
                                                        </div>
                                                    </div>
                                                )}
                                            </ComboboxOptions>
                                        </div>
                                    </Combobox>
                                </div>
                                
                                <div className="shrink-0 flex items-center gap-2 text-base opacity-50 select-none sm:text-sm/6">
                                    Customer
                                    <div className={`size-4 flex-none rounded-full p-1 ${selectedCustomer ? 'bg-emerald-500/30' : 'bg-red-500/30'}`}>
                                        <div className={`size-2 rounded-full ${selectedCustomer ? 'bg-emerald-500' : 'bg-red-500 animate-pulse'}`}/>
                                    </div>
                                </div>
                                
                                {/*Update Button*/}
                                <div className={`ml-2 ${isEditing ? 'hidden' : ''}`}>
                                    
                                    <Button onClick={accountLevel === "CSR" || accountLevel === "A" ? onUpdateCSR : onUpdateCustomer} className="hover:scale-110 h-fit duration-500 order-first flex items-center rounded-full bg-green-600 px-2 py-1 text-xxs font-medium text-white sm:order-none">
                                        <ArrowPathIcon className={`size-3 mr-1`}/>
                                        Sync
                                    </Button>
                                    
                                    {/*<ActionPillButton*/}
                                    {/*    color={"green"}*/}
                                    {/*    onClick={accountLevel === "CSR" ? onUpdateCSR : onUpdateCustomer}*/}
                                    {/*    icon={ArrowPathIcon}*/}
                                    {/*    label={"Sync"}*/}
                                    {/*/>*/}
                                    
                                </div>
                                
                            </div>
                        
                        </div>
                        
                        {/*INDUSTRY*/}
                        <div className={`col-span-1 m-1.5 flex items-center rounded-md border ${darkMode ? 'border-neutral-700 bg-darkMainColor' : 'bg-white'} px-2 `}>
                            <Input
                                required
                                disabled={true}
                                value={industry}
                                placeholder={`Select Customer`}
                                className="block min-w-0 grow bg-transparent py-1.5 pr-3 pl-1 text-base placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
                            />
                            <div
                                className="shrink-0 flex items-center gap-2 text-base opacity-50 select-none sm:text-sm/6">
                                Industry
                                
                                <div
                                    className={`size-4 flex-none rounded-full p-1 ${industry ? 'bg-emerald-500/30' : 'bg-red-500/30'}`}>
                                    <div
                                        className={`size-2 rounded-full ${industry ? 'bg-emerald-500' : 'bg-red-500 animate-pulse'}`}/>
                                </div>
                            
                            </div>
                        </div>
                        
                        {/*PRICING TYPE*/}
                        <div className={`col-span-1 m-1.5 flex items-center rounded-md border ${darkMode ? 'border-neutral-700 bg-darkMainColor' : 'bg-white'} px-2 `}>
                            <Select
                                className={`block min-w-0 grow bg-transparent py-2 pr-3 pl-1 text-base placeholder:text-gray-400 focus:outline-none sm:text-sm/6`}
                                value={priceType}
                                disabled={selectedCustomer || accountLevel === "DIST"}
                                onChange={(event) => setPriceType(event.target.value)} // Update priceType on selection change
                            >
                                <option value={priceType}>{pricingMapping[priceType] || "Select..."}</option>
                                {Object.entries(pricingMapping).map(([value, displayName]) => (
                                    <option key={value} value={value}>
                                        {displayName}
                                    </option>
                                ))}
                            </Select>
                            <div className="shrink-0 flex items-center gap-2 text-base opacity-50 select-none sm:text-sm/6">
                                Code
                                
                                <div className={`size-4 flex-none rounded-full p-1 ${customerCode ? 'bg-emerald-500/30' : 'bg-red-500/30'}`}>
                                    <div className={`size-2 rounded-full ${customerCode ? 'bg-emerald-500' : 'bg-red-500 animate-pulse'}`}/>
                                </div>
                            
                            </div>
                        </div>
                        
                        {/*CUSTOMER CODE*/}
                        <div className={`col-span-1 m-1.5 flex items-center rounded-md border ${darkMode ? 'border-neutral-700 bg-darkMainColor' : 'bg-white'} px-2 `}>
                            <Input
                                required
                                disabled={true}
                                value={customerCode}
                                placeholder={`Select Customer`}
                                className="block min-w-0 grow bg-transparent py-1.5 pr-3 pl-1 text-base placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
                            />
                            <div className="shrink-0 flex items-center gap-2 text-base opacity-50 select-none sm:text-sm/6">
                                Code
                                
                                <div className={`size-4 flex-none rounded-full p-1 ${customerCode ? 'bg-emerald-500/30' : 'bg-red-500/30'}`}>
                                    <div className={`size-2 rounded-full ${customerCode ? 'bg-emerald-500' : 'bg-red-500 animate-pulse'}`}/>
                                </div>
                            
                            </div>
                        </div>
                        
                        {/*PRODUCT SEARCH BAR*/}
                        <div className="col-span-full w-full flex flex-row">
                            
                            {/*Search Bar*/}
                            <div className="w-full flex flex-row items-center">
                                
                                <div className={`w-full m-1.5 flex items-center rounded-md border ${darkMode ? 'border-neutral-700 bg-darkMainColor' : 'bg-white'} px-2 `}>
                                    
                                    
                                    {/*Update Button*/}
                                    <div className={`mr-2`}>
                                        
                                        <Button onClick={onUpdate} className="hover:scale-110 h-fit duration-500 order-first flex items-center rounded-full bg-green-600 px-2 py-1 text-xxs font-medium text-white sm:order-none">
                                            <ArrowPathIcon className={`size-3 mr-1`}/>
                                            Sync
                                        </Button>
                                        
                                        {/*<ActionPillButton*/}
                                        {/*    color={"green"}*/}
                                        {/*    onClick={onUpdate}*/}
                                        {/*    icon={ArrowPathIcon}*/}
                                        {/*    label={"Sync"}*/}
                                        {/*/>*/}
                                    
                                    </div>
                                    
                                    <MagnifyingGlassIcon className="text-gray-600 size-5 mr-1 ml-1"/>
                                    
                                    <div className={`w-full`}>
                                        <Input
                                            className={`${darkMode ? 'bg-darkMainColor text-white' : 'bg-white'} transition-all tracking-widest placeholder:text-xs duration-500 ease-in-out rounded-md p-1 w-full focus:outline-none`}
                                            placeholder={`Search to add from ${products.length} products... Product Name, Product Code`}
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            // disabled={BulkOrder}
                                            onFocus={() => setShowProducts(true)}
                                            onBlur={() => setTimeout(() => setShowProducts(false), 100)} // Delay hiding to allow click
                                        />
                                    </div>
                                    
                                    
                                    {accountLevel !== 'DIST' && (
                                        <Button
                                            onClick={() => addProductInput()}
                                            className={`hover:text-green-600 w-1/6 flex items-center justify-center tracking-widest text-sm h-full ${darkMode ? 'text-white' : 'text-black'} rounded-md`}
                                        >
                                            <PlusIcon className={`size-4 stroke-2 mr-3`}/>
                                            Blank Item
                                            {/*{state}*/}
                                        </Button>
                                    )}
                                    
                                    
                                </div>
                                
                                <Button
                                    className={`${selectedCustomer ? 'bg-green-600 hover:bg-opacity-80' : 'bg-gray-400 cursor-not-allowed'} text-sm rounded-md ml-1.5 py-1.5 text-white w-1/6 line-clamp-1`}
                                    onClick={toggleVisibility}
                                    disabled={!selectedCustomer} // Disables if selectedCustomer is null
                                >
                                    Customer Orders
                                </Button>
                            
                            </div>
                            
                            {showProducts && (
                                <ul className={`absolute animate-fadeIn ${darkMode ? 'bg-neutral-800 text-white border border-gray-900' : 'bg-white border'} border rounded-md p-2 w-1/2 max-h-96 overflow-y-auto scrollbar-hide mt-12 z-10 shadow-lg`}>
                                    
                                    {filteredProducts.length > 0 ? (
                                        (() => {
                                            // Sorting filteredProducts before mapping over it
                                            const categoryOrder = categoryColors.map(c => c.category);
                                            filteredProducts.sort((a, b) => categoryOrder.indexOf(a.category) - categoryOrder.indexOf(b.category));
                                            
                                            return filteredProducts.map((product, index) => {
                                                const {color, shortened} = getCategoryInfo(product.category);
                                                
                                                return (
                                                    <li
                                                        key={product.id}
                                                        className={`cursor-pointer ${product.PLAIF ? 'opacity-50 bg-opacity-20 bg-gray-500' : ''} tracking-widest p-2 rounded-2xl flex items-center ${
                                                            darkMode ? 'hover:bg-darkMainColor' : 'hover:bg-gray-200'
                                                        }`}
                                                        onMouseDown={product.PLAIF ? undefined : () => addProductInput(product)} // Disable if PLAIF is true
                                                    >
                                                        <div className={`flex flex-row items-center w-full`}>
                                                            <div
                                                                className={`opacity-50 text-xxs mr-3 w-6`}>[{index + 1}]
                                                            </div>
                                                            
                                                            <div className="mr-3 flex size-12 items-center justify-center">
                                                                {product.category === 'Promotional Item' && product.promotionalImageUrl ? (
                                                                    <img
                                                                        src={product.promotionalImageUrl}
                                                                        alt={product.name}
                                                                        className="size-12 rounded-md object-contain"
                                                                    />
                                                                ) : <div
                                                                    className={`flex-none w-12 rounded-full p-1 ${color} bg-opacity-40 ${product.BULK ? 'hidden' : ''}`}>
                                                                    <div
                                                                        className={`text-xxs rounded-full ${color} bg-opacity-80 font-bold px-1 text-center text-white tracking-normal`}>
                                                                        {shortened}
                                                                    </div>
                                                                </div>}
                                                                
                                                                {product.category !== 'Promotional Item' && <LIME
                                                                    className={`${product.BULK ? '' : 'hidden'} size-7 text-green-600`}/>
                                                                }
                                                            </div>
                                                            
                                                            <div className={`line-clamp-1`}>{product.name}</div>
                                                        </div>
                                                    </li>
                                                );
                                            });
                                        })() // IIFE (Immediately Invoked Function Expression) to sort before rendering
                                    ) : (
                                        <div className={`flex items-center justify-center flex-col p-3`}>
                                            <EyeSlashIcon className={`w-6 stroke-2 opacity-50`}/>
                                            <div className="px-4 py-2 text-sm opacity-50">
                                                No product found for{' '}
                                                <span
                                                    className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}>'{searchTerm}'</span>.
                                                Please try again.
                                            </div>
                                        </div>
                                    )}
                                </ul>
                            )}
                        
                        </div>
                    
                    </div>
                    
                    {/*PRODUCT INPUT*/}
                    <div className={` col-span-full animate-glideInRight h-fit w-full flex flex-col`}>
                        
                        {/*PRODUCT LABELS*/}
                        <div className={`p-2 w-full flex flex-row  font-semibold border-b border-dashed ${darkMode ? ' border-neutral-700' : ''}`}>
                            
                            <div className={`w-full grid grid-cols-6 gap-x-3 ${darkMode ? 'text-white' : 'text-black'}`}>
                                
                                {/*PRODCUT NAME*/}
                                <div className="flex flex-row col-span-1">
                                    <div className="flex flex-col w-full">
                                        <div
                                            className="text-sm">Product{productInputs.length > 1 ? 's' : ''} [{productInputs.length}]
                                        </div>
                                    </div>
                                </div>
                                
                                {/*PRODUCT PRICING/QUANT*/}
                                <div className="col-span-4 grid grid-cols-8 gap-x-2">
                                    
                                    {/*PRICE*/}
                                    <div className="col-span-2 rounded-2xl h-full items-center justify-center">
                                        <div className="w-full text-sm">Price per U/M</div>
                                    </div>
                                    
                                    {/*QUANTITY*/}
                                    <div className="col-span-2 rounded-2xl h-full items-center justify-center">
                                        <div className="w-full text-sm">Quantity</div>
                                    </div>
                                    
                                    {/*VOLUME*/}
                                    <div className={`${accountLevel !== 'DIST' ? 'col-span-1' : 'col-span-2'} rounded-2xl h-full items-center justify-center`}>
                                        <div className="w-full text-sm">U/M</div>
                                    </div>
                                    
                                    {/*Warehouse*/}
                                    <div className="col-span-1 rounded-2xl h-full items-center justify-center">
                                        <div className="w-full text-sm">WH</div>
                                    </div>
                                    
                                    {/*DISC*/}
                                    {accountLevel !== 'DIST' && (
                                        <div className="col-span-1 rounded-2xl h-full items-center justify-center">
                                            <div className="w-full text-sm">Disc</div>
                                        </div>
                                    )}
                                    
                                    {/*No Charge*/}
                                    <div className="col-span-1 rounded-2xl h-full items-center justify-center">
                                        <div className="w-full text-sm">No Charge</div>
                                    </div>
                                
                                </div>
                                
                                {/*PRODUCT TOTAL*/}
                                <div className="flex flex-row col-span-1 justify-end align-middle items-center">
                                    
                                    <div className="ml-auto w-full flex flex-row justify-end">
                                        <div
                                            className="flex flex-row mt-auto mb-auto align-middle justify-end items-center">
                                            <div className="text-sm mr-3">Total</div>
                                        </div>
                                    </div>
                                
                                
                                </div>
                            
                            </div>
                        </div>
                        
                        {/*PRODUCT INPUT MAP*/}
                        <div className={`relative overflow-y-auto pb-2.5 scrollbar-hide min-h-96`}>
                            
                            {/*Map*/}
                            <div className={`overflow-y-auto min-h-96 overflow-x-hidden scrollbar-hide h-full border-b ${darkMode ? 'border-neutral-700' : ''}`}>
                                {productInputs.length === 0 ? (
                                    // Display custom dialog if sprays array is empty
                                    <div className="flex min-h-96 w-full h-full justify-center items-center">
                                        
                                        <div
                                            className={`flex items-center ${darkMode ? 'text-white border-neutral-700' : 'text-black bg-neutral-50'} w-fit px-24 py-3 h-fit mr-auto ml-auto justify-center rounded-2xl hover:scale-105`}>
                                            <div
                                                className="p-2 rounded-md shadow-gray-900 flex items-center justify-center flex-col m-2">
                                                <SquaresPlusIcon className={`w-10 stroke-1 mr-3`}/>
                                                <p className="text-xl mt-2 mb-2 line-clamp-1 tracking-widest flex">No
                                                    Products</p>
                                                <Button onClick={() => setShowProducts(true)}
                                                        disabled={!selectedCustomer}
                                                        className={`${!selectedCustomer ? 'bg-opacity-50' : ''} flex items-center bg-green-600 text-white px-4 py-1.5 rounded-2xl hover:bg-opacity-50 text-xs`}
                                                >
                                                    <PlusIcon className={`w-4 mr-2`}/>
                                                    {!selectedCustomer ? 'Select Customer' : 'Add Product'}
                                                </Button>
                                            </div>
                                        </div>
                                    
                                    </div>
                                ) : (
                                    productInputs.map((product, index) => {
                                        const matchedProduct = products.find((p) => p.id === product.id);
                                        return (
                                            <div key={product.key || product.uniqueKey}>
                                                <ProductInput
                                                    UniqueKey={product.key || product.uniqueKey} // <- Pass it like this
                                                    index={index}
                                                    accountLevel={accountLevel}
                                                    blank={product.blank || false}
                                                    onRemove={handleRemoveProduct}
                                                    onAdd={handleAddFinalProduct}
                                                    product={matchedProduct}
                                                    priceType={priceType}
                                                    discount={customerType}
                                                    isBulk={isBulk}
                                                    lineItem={product}
                                                    tankLocations={tankLocations}
                                                    contractPrices={contractPrices}
                                                    region={priceType}
                                                    early={earlyOrder}
                                                    prepay={prePay}
                                                    state={state}
                                                    
                                                />
                                            </div>
                                        )
                                    })
                                )}
                            </div>
                        
                        </div>
                    
                    </div>
                    
                    {/*PRODUCT TOTAL + NOTES + DELIVERY*/}
                    <div className={`col-span-full grid md:grid-cols-3 grid-cols-1 px-2 gap-3 animate-slideInBottom w-full`}>
                        
                        {/*Bottom Bar*/}
                        <div className={`col-span-2 grid md:grid-cols-3 gap-3 grid-cols-1 h-full rounded-2xl p-1 ${darkMode ? 'text-white' : 'text-black'}`}>
                            
                            {/*NOTES SECTION*/}
                            <div className="sm:col-span-1 col-span-full h-full">
                                <Textarea
                                    id=""
                                    name=""
                                    required
                                    autoComplete=""
                                    placeholder="Notes..."
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    className={`block w-full focus:outline-green-600 ${darkMode ? 'bg-darkBgColor text-white' : 'bg-white border ring-1 ring-inset ring-green-600'} p-2 h-full rounded-md shadow-gray-900 py-1.5 placeholder:text-gray-400`}
                                />
                            </div>
                            
                            {/*DELIVERY SECTION*/}
                            <div className="sm:col-span-1 col-span-full space-y-3">
                                
                                {/*Delivery Date*/}
                                <div className={`relative py-1.5`}>
                                    <label
                                        className={`absolute flex -top-1 z-40 left-3 rounded-2xl ${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-1 text-xs font-medium`}
                                    >
                                        Delivery Date
                                    </label>
                                    <Input
                                        id="date-input"
                                        name="date"
                                        type="date"
                                        value={deliveryDate}
                                        onChange={handleDeliveryDateChange}
                                        className={`block w-full px-4 focus:outline-green-600 rounded-md shadow-gray-900 py-1.5 border
                                        ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'}
                                        ${isToday ? 'border animate-pulse border-red-500 ring-red-500' : ''}`
                                        }
                                    />
                                </div>
                                
                                {/*Early Order*/}
                                {accountLevel !== 'DIST' && (
                                    <div className="flex items-center">
                                        
                                        <Field className="flex items-center">
                                            <Switch
                                                checked={earlyOrder}
                                                onChange={setEarlyOrder}
                                                disabled={customerType !== 0}
                                                className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                                            >
                                                <span className="sr-only">Use setting</span>
                                                <span aria-hidden="true"
                                                      className="pointer-events-none absolute size-full rounded-md"/>
                                                <span
                                                    aria-hidden="true"
                                                    className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                                                />
                                                <span
                                                    aria-hidden="true"
                                                    className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                />
                                            </Switch>
                                            <Label as="span" className="ml-3 text-sm">
                                                <span className="font-medium">Early Order</span>{' '}
                                                <span
                                                    className="opacity-50">{customerType !== 0 ? '(Disabled)' : '(Save 5%)'}</span>
                                                {/*<span className="opacity-50">(Disabled)</span>*/}
                                            </Label>
                                        </Field>
                                    
                                    </div>
                                )}
                                
                                {/*Prepay*/}
                                {accountLevel !== 'DIST' && (
                                    <div className="flex items-center">
                                        
                                        <Field className="flex items-center">
                                            <Switch
                                                checked={prePay}
                                                onChange={setPrePay}
                                                disabled={customerType !== 0}
                                                className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                                            >
                                                <span className="sr-only">Use setting</span>
                                                <span aria-hidden="true"
                                                      className="pointer-events-none absolute size-full rounded-md"/>
                                                <span
                                                    aria-hidden="true"
                                                    className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                                                />
                                                <span
                                                    aria-hidden="true"
                                                    className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                />
                                            </Switch>
                                            <Label as="span" className="ml-3 text-sm">
                                                <span className="font-medium">Prepay Order</span>{' '}
                                                <span
                                                    className="opacity-50">{customerType !== 0 ? '(Disabled)' : '(Save 3%)'}</span>
                                                {/*<span className="opacity-50">(Disabled)</span>*/}
                                            </Label>
                                        </Field>
                                    
                                    </div>
                                )}
                                
                                {/*ASAP*/}
                                <div className="flex items-center">
                                    
                                    <Field className="flex items-center">
                                        <Switch
                                            checked={ASAP}
                                            onChange={setASAP}
                                            className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                                        >
                                            <span className="sr-only">Use setting</span>
                                            <span aria-hidden="true"
                                                  className="pointer-events-none absolute size-full rounded-md"/>
                                            <span
                                                aria-hidden="true"
                                                className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                                            />
                                            <span
                                                aria-hidden="true"
                                                className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                        </Switch>
                                        <Label as="span" className="ml-3 text-sm">
                                            <span className="font-medium">ASAP Order</span>{' '}
                                            {/*<span className="opacity-50">(Save 10%)</span>*/}
                                        </Label>
                                    </Field>
                                
                                </div>
                                
                                {/*Consume Prepay*/}
                                {accountLevel !== 'DIST' && (
                                    <div className="flex items-center">
                                        
                                        <Field className="flex items-center">
                                            <Switch
                                                checked={consumePre}
                                                onChange={setConsumePre}
                                                className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                                            >
                                                <span className="sr-only">Use setting</span>
                                                <span aria-hidden="true"
                                                      className="pointer-events-none absolute size-full rounded-md"/>
                                                <span
                                                    aria-hidden="true"
                                                    className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                                                />
                                                <span
                                                    aria-hidden="true"
                                                    className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                />
                                            </Switch>
                                            <Label as="span" className="ml-3 text-sm">
                                                <span className="font-medium">Consume Prepayr</span>{' '}
                                                {/*<span className="opacity-50">(Save 10%)</span>*/}
                                            </Label>
                                        </Field>
                                    
                                    </div>
                                )}
                            
                            </div>
                            
                            {/*SHIPPING SECTION*/}
                            <div className="sm:col-span-1 col-span-full space-y-3">
                                
                                {/*Shipping Locations*/}
                                <div className={`relative py-1.5`}>
                                    <label
                                        className={`absolute flex -top-1 z-40 left-3 rounded-2xl ${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-1 text-xs font-medium`}
                                    >
                                        Shipping Location
                                    </label>
                                    
                                    <Select
                                        className={`block w-full px-4 focus:outline-green-600 border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'} rounded-md py-2`}
                                        onChange={(e) => {
                                            const selectedName = e.target.value;
                                            
                                            if (!selectedName) {
                                                // setAddress(`${customer.address1} ${customer.city}, ${customer.state} ${customer.zip}`);
                                                return;
                                            }
                                            
                                            const selectedLocation = shippingLocations.find(
                                                (loc) => loc.address1 === selectedName
                                            );
                                            
                                            if (selectedLocation) {
                                                const newAddress = `${selectedLocation.address1} ${selectedLocation.city}, ${selectedLocation.selectedState} ${selectedLocation.zip}`;
                                                console.log('Selected Shipping Address:', newAddress); // Debug log
                                                setAddress(newAddress);
                                            } else {
                                                console.log("No matching location found for:", selectedName); // Debug
                                            }
                                        }}
                                    >
                                        <option value="">Select Shipping Location...</option>
                                        {Array.isArray(shippingLocations) && shippingLocations.length > 0 ? (
                                            shippingLocations.map((location, index) => (
                                                <option key={index} value={location.address1}>
                                                    {location.address1}
                                                </option>
                                            ))
                                        ) : (
                                            <option disabled>No shipping locations available</option>
                                        )}
                                    </Select>
                                   
                                </div>
                                
                                {/*Call Before*/}
                                <div className="flex items-center">
                                    
                                    <Field className="flex items-center">
                                        <Switch
                                            checked={callBefore}
                                            onChange={setCallBefore}
                                            className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                                        >
                                            <span className="sr-only">Use setting</span>
                                            <span aria-hidden="true"
                                                  className="pointer-events-none absolute size-full rounded-md"/>
                                            <span
                                                aria-hidden="true"
                                                className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                                            />
                                            <span
                                                aria-hidden="true"
                                                className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                        </Switch>
                                        <Label as="span" className="ml-3 text-sm">
                                            <span className="font-medium">Call Before Delivery</span>{' '}
                                            {/*<span className="opacity-50">(Save 10%)</span>*/}
                                        </Label>
                                    </Field>
                                
                                </div>
                                
                                {accountLevel !== "DIST" && (
                                    <ShortOrderFreight
                                        products={finalProducts}
                                        onFreightChange={setEstimatedFreight}
                                        accountLevel={accountLevel}
                                    />
                                )}
                            
                            </div>
                        
                        </div>
                        
                        {/*TOTAL SECTION*/}
                        <div className={`col-span-1 grid grid-cols-4 min-h-48 ${darkMode ? 'bg-white/5 border border-neutral-700/50 text-white' : 'bg-black/5 border text-black'} drop-shadow rounded-xl flex flex-row p-1.5`}>
                            <div className="col-span-2">
                                <div className="h-1/3 flex items-center text-xs">SubTotal:</div>
                                
                                <div className="h-1/3 flex items-center text-xs gap-x-3">
                                    <span className={``}>{isBulk ? 'Bulk Discount:' : 'Discount:'}</span>
                                    {/*(+/- {customerType}%):*/}
                                    <div className={`h-8 w-28`}>
                                        {accountLevel !== "DIST" && (
                                            <StepperInput
                                                value={customerType}
                                                onChange={(val) => setCustomerType(val)} // ✅ THIS IS ALL YOU NEED
                                                step={0.5}
                                                placeholder="DISC"
                                                disabled={
                                                    (initialCustomerType > 0 || accountLevel === "DIST") &&
                                                    accountLevel !== "CSR" &&
                                                    accountLevel !== "D" &&
                                                    accountLevel !== "A"
                                                }
                                            />
                                        )}
                                        
                                        {/*{initialCustomerType}*/}
                                    </div>
                                </div>
                               
                                <div className="h-1/3 flex flex-col">
                                    <div className="flex text-lg">Total:</div>
                                    <div className="flex text-gray-400 text-xxs line-clamp-1">*Before Applicable Taxes & Freight | {estimatedFreight}</div>
                                </div>
                            </div>
                            <div className="col-span-2">
                                <div className="h-1/3 flex items-center justify-end text-xs">
                                    <div className="mr-3">$</div>
                                    <div className="mr-3 tracking-wider">{numberWithCommas(subTotal.toFixed(2))}</div>
                                    <div className="text-borderColor">USD</div>
                                </div>
                                <div className="h-1/3 flex items-center justify-end text-xs">
                                    <div className="mr-3">$</div>
                                    <div className="mr-3 tracking-wider">{numberWithCommas(discount)}</div>
                                    <div className="">USD</div>
                                </div>
                                <div className="h-1/3 flex items-center justify-end stext-lg">
                                    <div className="mr-3">$</div>
                                    <div className="mr-3 tracking-wider">{numberWithCommas( calculateDiscountedTotal(state, grandTotal, earlyOrder, prePay, estimatedFreight)) }*</div>
                                    {/*<div className="mr-3 tracking-wider">{numberWithCommas(grandTotal.toFixed(2))}*</div>*/}
                                    <div className="">USD</div>
                                </div>
                            </div>
                        </div>

                    </div>
                    
                    {/*ORDER FORM FOOTER [Buttons]*/}
                    <div className=" col-span-full animate-slideInBottom w-full flex h-fit p-2">
                        
                        {/*Submit*/}
                        <div className={`${isEditing ? 'hidden' : ''} text-xl text-black w-1/2`}>
                            <div className="flex w-full flex-row items-start align-middle justify-start h-full">
    
                                <Button className={`${!selectedCustomer ? 'bg-opacity-50' : 'hover:scale-105'} ${darkMode ? 'bg-green-600 text-white' : 'bg-green-600 drop-shadow'} hover:bg-opacity-50 rounded-md py-1.5 px-6 text-white text-sm mr-3 transition-all duration-500 ease-in-out`}
                                    onClick={toggleSubmitting}
                                    disabled={!selectedCustomer}
                                >Submit Order</Button>
    
                                <Button className={`border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white drop-shadow'} hover:scale-105 hover:bg-opacity-50 rounded-md py-1.5 px-6 text-black text-sm mr-3 drop-shadow shadow-gray-900 transition-all duration-500 ease-in-out`}
                                    onClick={clear}
                                    // onClick={handleClick}
                                >Clear</Button>
    
                            </div>
                        </div>
                        
                        {/*Planned*/}
                        <div className={`${isEditing ? 'hidden' : ''} text-xl w-1/2`}>
                            <div className="flex w-full flex-row items-end align-middle justify-end h-full">
    
                                {quoteToolTip && (
                                    <div className={`mr-5 border ${darkMode ? 'bg-darkBgColor border-neutral-700 text-white' : 'bg-bgColor text-black'} text-xs rounded p-1`}>
                                        Download Order as a Quote
                                    </div>
                                )}
                                
                                <Button
                                    className="rounded-full mt-auto mr-3 mb-auto w-fit items-center justify-center align-middle transition-all duration-500 ease-in-out"
                                    onClick={downloadQuotePDF}
                                    disabled={!selectedCustomer && !priceType}
                                    onMouseEnter={() => setQuoteToolTip(true)}
                                    onMouseLeave={() => setQuoteToolTip(false)}
                                >
                                    <img
                                        alt=""
                                        src={pdfIcon}
                                        className={`flex-none h-8 ${!selectedCustomer && !priceType ? 'bg-neutral-700 bg-opacity-50 border rounded-2xl border-red-500' : 'hover:animate-heartbeat'}`}
                                    />
                                    {/*<DocumentArrowDownIcon className={`h-8 text-borderColor ${!selectedCustomer ? 'text-opacity-50' : 'hover:text-green-600 hover:animate-heartbeat'} m-auto transition-all duration-500 ease-in-out`}/>*/}
                                </Button>
                                
                                <Button
                                    className={`${!selectedCustomer ? 'bg-opacity-50' : 'hover:scale-105'} ${darkMode ? 'text-white' : 'text-white drop-shadow'} bg-blue-500 hover:bg-opacity-50 rounded-md py-1.5 px-6 text-sm transition-all duration-500 ease-in-out`}
                                    onClick={togglePlanned}
                                    disabled={!selectedCustomer}
                                >Save Order as Planned</Button>
    
                            </div>
                        </div>
                        
                        
                        {/*Editing*/}
                        <div className={`${isEditing ? '' : 'hidden'} text-xl w-full`}>
                            <div className="flex w-full flex-row items-center justify-center h-full">
                                
                                <Button
                                    className={`hover:scale-105 ${darkMode ? 'text-white' : 'text-white drop-shadow'} w-1/2 bg-blue-500 hover:bg-opacity-50 rounded-md py-1.5 px-6 text-sm transition-all duration-500 ease-in-out`}
                                    onClick={toggleUpdating}
                                    disabled={false}
                                >Update Existing Order</Button>
    
                            </div>
                        </div>
                        
                        {/*Back*/}
                        <div className={`${isEditing ? '' : 'hidden'} absolute text-xl`}>
                            <div className="flex flex-row items-center justify-center h-full">
                                
                                <Button className={`flex items-center border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white drop-shadow'} hover:scale-105 hover:bg-opacity-50 rounded-md py-1.5 px-6 text-black text-sm mr-3 drop-shadow shadow-gray-900 transition-all duration-500 ease-in-out`}
                                    onClick={close}
                                    disabled={false}
                                >
                                    <ArrowLeftIcon className={`w-4 mr-3 stroke-2`}/>
                                    Back
                                </Button>
    
                            </div>
                        </div>
                        
                        
                    </div>
                    
                </div>
                

            </div>

            
            
            <Dialog open={isSubmitting} onClose={setIsSubmitting} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-2xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                        <PaperAirplaneIcon aria-hidden="true" className="size-6 text-green-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Submit Order to Plant
                        </DialogTitle>
                        <BulkProductConfirmation
                        products={bulkProducts}
                        confirmed={bulkConfirmed}
                        onChange={checked => setConfirmedBulkKey(checked ? bulkKey : null)}
                    />
                          <div className="mt-2">
                              <p className="text-sm opacity-50">
                                  Submitting this order is sending it to the Plant for fulfillment. A Submitted order
                                  may not be edited so make sure all information is correct.
                              </p>
                              
                              {/*Shipping Section Confirm*/}
                              <div className={`text-sm mt-2 space-y-1`}>
                                  
                                  {/*Divider*/}
                                  <div className="relative">
                                      <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                          <div className={`w-full border-t ${darkMode ? 'border-neutral-700' : ''}`}/>
                                      </div>
                                      <div className="relative flex justify-center">
                                          <span
                                              className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-2 text-sm`}>Shipping Address</span>
                                      </div>
                                  </div>
                                  
                                  {/*Current Address*/}
                                  <div className={`py-3`}>{address || "No Address On File"}</div>
                                  
                                  {/*Shipping Location Selector*/}
                                  <div className={`relative py-1.5`}>
                                      <label
                                          className={`absolute flex -top-1 z-40 left-3 rounded-2xl ${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-1 text-xs font-medium`}
                                      >
                                          Change Shipping Location
                                      </label>
                                      
                                      <Select
                                          className={`block w-full px-4 focus:outline-green-600 border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'} rounded-md py-2`}
                                          onChange={(e) => {
                                              const selectedName = e.target.value;
                                              
                                              if (!selectedName) {
                                                  // setAddress(`${customer.address1} ${customer.city}, ${customer.state} ${customer.zip}`);
                                                  return;
                                              }
                                              
                                              const selectedLocation = shippingLocations.find(
                                                  (loc) => loc.address1 === selectedName
                                              );
                                              
                                              if (selectedLocation) {
                                                  const newAddress = `${selectedLocation.address1} ${selectedLocation.city}, ${selectedLocation.selectedState} ${selectedLocation.zip}`;
                                                  console.log('Selected Shipping Address:', newAddress); // Debug log
                                                  setAddress(newAddress);
                                              } else {
                                                  console.log("No matching location found for:", selectedName); // Debug
                                              }
                                          }}
                                      >
                                          <option value="">Select Shipping Location...</option>
                                          {Array.isArray(shippingLocations) && shippingLocations.length > 0 ? (
                                              shippingLocations.map((location, index) => (
                                                  <option key={index} value={location.name}>
                                                      {location.address1}
                                                  </option>
                                              ))
                                          ) : (
                                              <option disabled>No shipping locations available</option>
                                          )}
                                      </Select>
                                      
                                      {/*<Select*/}
                                      {/*    className={`block w-full px-4 focus:outline-green-600 border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'} rounded-md py-2`}*/}
                                      {/*    // value={status}*/}
                                      {/*    // onChange={(e) => filterProgramsByCatagory(e.target.value)}*/}
                                      {/*>*/}
                                      {/*    <option value="">Select Shipping Location...</option>*/}
                                      {/*    {Array.isArray(shippingLocations) && shippingLocations.length > 0 ? (*/}
                                      {/*        shippingLocations.map((location, index) => (*/}
                                      {/*            <option key={index} value={location.name}>*/}
                                      {/*                {location.address1}*/}
                                      {/*            </option>*/}
                                      {/*        ))*/}
                                      {/*    ) : (*/}
                                      {/*        <option disabled>No shipping locations available</option>*/}
                                      {/*    )}*/}
                                      {/*</Select>*/}
                                  </div>
                                  
                                  {/*Label*/}
                                  <div className={`text-xs opacity-50`}>Edit or Add Address in Customer Management // Account View</div>
                                  
                                  {/*Label*/}
                                  <div className="text-xs">
                                      Please confirm that the shipping address is correct. If not, select a different one from the dropdown below.
                                      If no options are correct, go to the Account View to edit or add a new shipping location.
                                  </div>
                                  
                                  {/*Confirm*/}
                                  <div className="flex gap-3 w-full">
                                      <div className="flex h-6 ml-auto shrink-0 items-center">
                                      <div className="group grid size-3.5 grid-cols-1">
                                              <Input
                                                  type="checkbox"
                                                  checked={addressConfirm}
                                                  onChange={() => setAddressConfirm(!addressConfirm)}
                                                  className={`col-start-1 row-start-1 appearance-none rounded border border-gray-300 ${darkMode ? 'bg-darkMainColor' : 'bg-white'} checked:border-green-600 checked:bg-green-600 indeterminate:border-green-600 indeterminate:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto`}
                                              />
                                              <svg
                                                  fill="none"
                                                  viewBox="0 0 14 14"
                                                  className="pointer-events-none col-start-1 row-start-1 size-2.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                                              >
                                                  <path
                                                      d="M3 8L6 11L11 3.5"
                                                      strokeWidth={2}
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      className="opacity-0 group-has-[:checked]:opacity-100"
                                                  />
                                                  <path
                                                      d="M3 7H11"
                                                      strokeWidth={2}
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      className="opacity-0 group-has-[:indeterminate]:opacity-100"
                                                  />
                                              </svg>
                                          </div>
                                      </div>
                                      <div className="text-xs/6">
                                          <label className="font-medium">
                                              Confirm Address
                                          </label>
                                      </div>
                                  </div>
                                  
                                  {/*PO-Number*/}
                                  <div className={`relative py-1.5`}>
                                      <label
                                          className={`absolute flex -top-1 z-40 left-3 rounded-2xl ${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-1 text-xs font-medium`}
                                      >
                                          PO-Number
                                      </label>
                                      <Input
                                          type="string"
                                          value={poNum}
                                          placeholder={`Enter PO-Number (Optional)`}
                                          onChange={(e) => setPoNum(e.target.value)}
                                          className={`block w-full px-4 focus:outline-green-600 rounded-md shadow-gray-900 py-1.5 border placeholder:text-xs
                                            ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'}`}
                                      />
                                  </div>
                              
                              </div>
                          
                          </div>
                      </div>
                    </div>
                    
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                          <Button
                              type="button"
                              onClick={onSubmitPending}
                              disabled={!addressConfirm || !bulkConfirmed}
                              className={`${!addressConfirm || !bulkConfirmed ? 'bg-opacity-50' : ''} inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                          >
                              {!addressConfirm ? 'Confirm Address' : !bulkConfirmed ? 'Confirm BUL Products' : 'Submit New Order'}
                          </Button>
                          <Button
                              type="button"
                              data-autofocus
                              onClick={toggleSubmitting}
                              className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                          >
                              Cancel
                          </Button>
                      </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
            
            <Dialog open={errorUpdate} onClose={setErrorUpdate} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                
                <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-600/15 sm:mx-0 sm:size-10">
                                    <PaperAirplaneIcon aria-hidden="true" className="size-6 text-red-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Error Updating Order
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm opacity-50">
                                            This order has an error when trying to update its contents. This may be for
                                            multiple reasons. Please Contact Spencer!
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <Button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setErrorUpdate(false)}
                                    className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </DialogPanel>
                </div>
              </div>
            </Dialog>

            <Dialog open={isPlanned} onClose={setIsPlanned} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-2xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-blue-500/15 sm:mx-0 sm:size-10">
                        <PaperAirplaneIcon aria-hidden="true" className="size-6 text-blue-500" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Save Order As Planned
                        </DialogTitle>
                        <BulkProductConfirmation
                        products={bulkProducts}
                        confirmed={bulkConfirmed}
                        onChange={checked => setConfirmedBulkKey(checked ? bulkKey : null)}
                    />
                        <div className="mt-2">
                          <p className="text-sm opacity-50">
                            Are you sure you want to save this Order? This order will be saved to your account
                              but not sent to the plant for fulfillment. Your CSR rep will not be able to see this order.
                          </p>
                            
                            {/*Shipping Section Confirm*/}
                              <div className={`text-sm mt-2 space-y-1`}>
                                  
                                  {/*Divider*/}
                                  <div className="relative">
                                      <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                        <div className={`w-full border-t ${darkMode ? 'border-neutral-700' : ''}`}/>
                                      </div>
                                      <div className="relative flex justify-center">
                                        <span className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-2 text-sm`}>Ship To Address</span>
                                      </div>
                                  </div>
                                  
                                  {/*Current Address*/}
                                  <div className={`py-3`}>{address || "No Address On File"}</div>
                                  
                                  {/*Shipping Location Selector*/}
                                  <div className={`relative py-1.5`}>
                                      <label
                                          className={`absolute flex -top-1 z-40 left-3 rounded-2xl ${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-1 text-xs font-medium`}
                                      >
                                         Change Shipping Location
                                      </label>
                                      
                                      <select
                                          className={`block w-full px-4 focus:outline-green-600 border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'} rounded-md py-2`}
                                          onChange={(e) => {
                                              const selectedName = e.target.value;
                                              
                                              if (!selectedName) {
                                                  // setAddress(`${customer.address1} ${customer.city}, ${customer.state} ${customer.zip}`);
                                                  return;
                                              }
                                              
                                              const selectedLocation = shippingLocations.find(
                                                  (loc) => loc.address1 === selectedName
                                              );
                                              
                                              if (selectedLocation) {
                                                  const newAddress = `${selectedLocation.address1} ${selectedLocation.city}, ${selectedLocation.selectedState} ${selectedLocation.zip}`;
                                                  console.log('Selected Shipping Address:', newAddress); // Debug log
                                                  setAddress(newAddress);
                                              } else {
                                                  console.log("No matching location found for:", selectedName); // Debug
                                              }
                                          }}
                                      >
                                          <option value="">Select Shipping Location...</option>
                                          {Array.isArray(shippingLocations) && shippingLocations.length > 0 ? (
                                              shippingLocations.map((location, index) => (
                                                  <option key={index} value={location.name}>
                                                      {location.address1}
                                                  </option>
                                              ))
                                          ) : (
                                              <option disabled>No shipping locations available</option>
                                          )}
                                      </select>
                                      
                                      {/*<Select*/}
                                      {/*    className={`block w-full px-4 focus:outline-green-600 border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'} rounded-md py-2`}*/}
                                      {/*    // value={status}*/}
                                      {/*    // onChange={(e) => filterProgramsByCatagory(e.target.value)}*/}
                                      {/*>*/}
                                      {/*    <option value="">Select Shipping Location...</option>*/}
                                      {/*    {Array.isArray(shippingLocations) && shippingLocations.length > 0 ? (*/}
                                      {/*        shippingLocations.map((location, index) => (*/}
                                      {/*            <option key={index} value={location.name}>*/}
                                      {/*                {location.address1}*/}
                                      {/*            </option>*/}
                                      {/*        ))*/}
                                      {/*    ) : (*/}
                                      {/*        <option disabled>No shipping locations available</option>*/}
                                      {/*    )}*/}
                                      {/*</Select>*/}
                                  </div>
                                  
                                  {/*Label*/}
                                  <div className={`text-xs opacity-50`}>Edit or Add Address in Customer Management</div>
                                  
                                  {/*Confirm*/}
                                  <div className="flex gap-3 w-full">
                                      <div className="flex h-6 ml-auto shrink-0 items-center">
                                          <div className="group grid size-3.5 grid-cols-1">
                                              <Input
                                                  type="checkbox"
                                                  checked={addressConfirm}
                                                  onChange={() => setAddressConfirm(!addressConfirm)}
                                                  className={`col-start-1 row-start-1 appearance-none rounded border border-gray-300 ${darkMode ? 'bg-darkMainColor' : 'bg-white'} checked:border-green-600 checked:bg-green-600 indeterminate:border-green-600 indeterminate:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto`}
                                              />
                                              <svg
                                                  fill="none"
                                                  viewBox="0 0 14 14"
                                                  className="pointer-events-none col-start-1 row-start-1 size-2.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                                              >
                                                  <path
                                                      d="M3 8L6 11L11 3.5"
                                                      strokeWidth={2}
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      className="opacity-0 group-has-[:checked]:opacity-100"
                                                  />
                                                  <path
                                                      d="M3 7H11"
                                                      strokeWidth={2}
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      className="opacity-0 group-has-[:indeterminate]:opacity-100"
                                                  />
                                              </svg>
                                          </div>
                                      </div>
                                      <div className="text-xs/6">
                                          <label className="font-medium">
                                              Confirm Address
                                          </label>
                                      </div>
                                  </div>
                                  
                                  {/*PO-Number*/}
                                  <div className={`relative py-1.5`}>
                                      <label
                                          className={`absolute flex -top-1 z-40 left-3 rounded-2xl ${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-1 text-xs font-medium`}
                                      >
                                          PO-Number
                                      </label>
                                      <Input
                                          type="string"
                                          value={poNum}
                                          placeholder={`Enter PO-Number (Optional)`}
                                          onChange={(e) => setPoNum(e.target.value)}
                                          className={`block w-full px-4 focus:outline-green-600 rounded-md shadow-gray-900 py-1.5 border placeholder:text-xs
                                            ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'}`}
                                      />
                                  </div>
                              
                              </div>
                            
                        </div>
                      </div>
                    </div>
                    
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={onSubmitPlanned}
                        disabled={!addressConfirm || !bulkConfirmed}
                        className={`${!addressConfirm || !bulkConfirmed ? 'bg-opacity-50' : ''} inline-flex w-full justify-center rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                      >
                          {!addressConfirm ? 'Confirm Address' : !bulkConfirmed ? 'Confirm BUL Products' : 'Save Order as Planned'}
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={togglePlanned}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        Cancel
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
            
            <Dialog open={isUpdating} onClose={setIsUpdating} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-blue-500/15 sm:mx-0 sm:size-10">
                        <PencilIcon aria-hidden="true" className="size-6 text-blue-500" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Update Existing Order
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="text-sm opacity-50">
                            Are you sure you want to edit this Order? Editing this order will perminately change the data for this order. If you are a sales Rep once your order is submitted you cannot edit it further.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={onSubmittingUpdating}
                        className={`inline-flex w-full justify-center rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                      >
                        Update Order
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={toggleUpdating}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        Cancel
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
            
            <Dialog open={isNoPhone} onClose={setIsNoPhone} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-500/15 sm:mx-0 sm:size-10">
                        <PhoneIcon aria-hidden="true" className="size-6 text-green-500" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Missing Phone Number
                        </DialogTitle>
                          <div className="mt-2">
                              <p className="text-sm opacity-50">
                                  It appears that you would like to add a "Call Before Delivery" option on this order.
                                  IT does not appear to be a phone number on file for this customer. Please add one
                                  below!
                              </p>
                              <div className={`relative mt-4`}>
                                  <label
                                      className={`absolute flex -top-2 left-2 rounded-2xl ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                  >
                                      Customer Phone Number
                                  </label>
                                  <Input
                                      type="text"
                                      value={customerPhone}
                                      onChange={(e) => setCustomerPhone(e.target.value)}
                                      placeholder={`123-456-7890`}
                                      className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300 outline-2'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                  />
                              </div>
                          </div>
                      </div>
                    </div>
                      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                          <Button
                              type="button"
                              onClick={() => setIsNoPhone(false)}
                              // onClick={onSubmittingUpdating}
                              className={`inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                          >
                              I Understand
                          </Button>
                          <Button
                              type="button"
                              data-autofocus
                              onClick={() => setIsNoPhone(false)}
                              className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                          >
                              Cancel
                          </Button>
                      </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>

            

            <Dialog open={open} onClose={setOpen} className={`relative z-50 ${darkMode ? 'text-white' : 'text-black'}`}>
                
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/20 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
                  />
                
                <div className="fixed inset-0 font-mono overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full h-full pl-10 py-3">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                            >
                                <div className={`flex flex-col h-full border ${darkMode ? 'bg-darkMainColor border-neutral-700' : 'bg-white'} shadow-2xl mr-3 rounded-2xl`}>
                                    
                                    
                                    <div className={`px-4 sm:px-6 pt-6`}>
                                        <div className="flex items-start justify-between">
                                            <DialogTitle className="text-base font-semibold">New Order Form Reference</DialogTitle>
                                            <div className="ml-3 flex h-7 items-center">
                                                <Button
                                                    type="button"
                                                    onClick={() => setOpen(false)}
                                                    className="relative rounded-md opacity-50 hover:text-opacity-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                                >
                                                    <span className="absolute -inset-2.5" />
                                                    <span className="sr-only">Close panel</span>
                                                    <ChevronDoubleRightIcon aria-hidden="true" className="size-6" />
                                                </Button>
                                            </div>
                                        </div>
                                    </div>


                                    {/*Body*/}
                                    <div className={`relative mt-5 flex-1 px-4 sm:px-6 flex-col border-t-2 h-[calc(100dvh-4rem)] overflow-y-scroll scrollbar-hide space-y-12 pt-3 ${darkMode ? 'border-neutral-700': ''}`}>

                                        {/*Green*/}
                                        <div className={`flex flex-row items-center`}>

                                            <div className={`mr-6`}>
                                                <div className={`flex-none rounded-full p-1 bg-emerald-500/30`}>
                                                    <div className={`size-2 rounded-full bg-emerald-500`}/>
                                                </div>
                                            </div>

                                            <div className={``}>
                                                <div className={`font-bold text-emerald-500`}>Green Indicators [Good]</div>
                                                <div className={`text-sm ml-3 opacity-50`}>These indicators appear in the corner of fields that are correctly filled out and properly formatted. They signify that all necessary information for these fields has been provided, ensuring accurate order processing. On a product input card, their presence confirms that pricing is available for the selected item within the specified industry.</div>
                                            </div>

                                        </div>

                                        {/*Red*/}
                                        <div className={`flex flex-row items-center`}>

                                            <div className={`mr-6`}>
                                                <div className={`flex-none rounded-full p-1 bg-red-500/30 animate-heartbeat`}>
                                                    <div className={`size-2 rounded-full bg-red-400`}/>
                                                </div>
                                            </div>

                                            <div className={``}>
                                                <div className={`font-bold text-red-500`}>Red Indicators [Error]</div>
                                                <div className={`text-sm ml-3 opacity-50`}>These pulsating indicators appear in the corner of fields that are either incorrectly formatted or left incomplete. They highlight essential fields required for proper order formatting. Additionally, if these indicators are present on a product input card, it signifies that pricing is unavailable for the selected item within the specified industry.</div>
                                            </div>

                                        </div>

                                        {/*Blue*/}
                                        <div className={`flex flex-row items-center`}>

                                            <div className={`mr-6`}>
                                                <div className={`flex-none rounded-full p-1 bg-blue-500/30 animate-heartbeat`}>
                                                    <div className={`size-2 rounded-full bg-blue-500`}/>
                                                </div>
                                            </div>

                                            <div className={``}>
                                                <div className={`font-bold text-blue-500`}>Blue Indicators [Discount]</div>
                                                <div className={`text-sm ml-3 opacity-50`}>These indicators appear above the total price fields within product input cards. Their presence signifies that a discount has been applied to the corresponding line item in the order.</div>
                                            </div>

                                        </div>

                                        {/*Yellow*/}
                                        <div className={`flex flex-row items-center`}>

                                            <div className={`mr-6`}>
                                                <div className={`flex-none rounded-full p-1 bg-yellow-500/30`}>
                                                    <div className={`size-2 rounded-full bg-yellow-500`}/>
                                                </div>
                                            </div>

                                            <div className={``}>
                                                <div className={`font-bold text-yellow-500`}>Yellow Indicators [Contract]</div>
                                                <div className={`text-sm ml-3 opacity-50`}>These are indicators appear above the pricing field to indicate that a contract price has been recognized and automatically applied to the order form.</div>
                                            </div>

                                        </div>
                                        
                                        {/*Grey*/}
                                        <div className={`flex flex-row items-center`}>

                                            <div className={`mr-6`}>
                                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                                    <LockClosedIcon className={`size-6 stroke-2 rounded-full text-slate-500`}/>
                                                </div>
                                            </div>

                                            <div className={``}>
                                                <div className={`font-bold text-slate-500`}>Grey Indicators [Locked]</div>
                                                <div className={`text-sm ml-3 opacity-50`}>These are indicators appear above the pricing field to indicate that this products price is locked and you may not apply any discounts to this price. This is because those products are not PFC products and we do not set the price.</div>
                                            </div>

                                        </div>
                                        
                                        {/*Blue Pencil*/}
                                        <div className={`flex flex-row items-center`}>

                                            <div className={`mr-6`}>
                                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                                    <PencilIcon className={`size-6 stroke-2 text-blue-500`}/>
                                                </div>
                                            </div>

                                            <div className={``}>
                                                <div className={`font-bold text-blue-500`}>Blue Pencil [Editted]</div>
                                                <div className={`text-sm ml-3 opacity-50`}>These are indicators appear above the pricing field to indicate that this products price has been physically edited by the Sales Rep. The Sales Rep is authorized to edit a max of 15% off of the "sticker" price however this icon appears so that the CSR back in the office knows that an edited order has been entered. This feature is disabled if any other discount is applied.</div>
                                            </div>

                                        </div>
                                        
                                        {/*Red BankNotes*/}
                                        <div className={`flex flex-row items-center pb-16`}>

                                            <div className={`mr-6`}>
                                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                                    <BanknotesIcon className={`size-6 stroke-2 text-red-600 animate-heartbeat`}/>
                                                </div>
                                            </div>

                                            <div className={``}>
                                                <div className={`font-bold text-red-600`}>Red BankNote [Request]</div>
                                                <div className={`text-sm ml-3 opacity-50`}>These are indicators appear in the pricing field next to the dollar sign when there is not a price in the system that matches that customer. You may add in a price to this field which will be sent into your CSR rep. This price may be denied and edited by the plant.</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog open={isToday} onClose={setIsToday} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-600/15 sm:mx-0 sm:size-10">
                        <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Order Date Error
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="text-sm opacity-50">
                            Are you sure you want to set this date as the Delivery Date? You chose the delivery date to be today, This may cause errors in shipping and Freight.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={() => setDeliveryDate("")}
                        className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                      >
                        Change Date
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={() => setIsToday(false)}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        I Understand
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
            
            
            <Dialog open={browse} onClose={setBrowse} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 font-mono bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
        
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-6xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                    <ClipboardDocumentListIcon aria-hidden="true" className="size-6 text-green-600" />
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Browse {customerCode}'s Past Orders
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm opacity-50">
                                             Are you sure you want to set this date as the Delivery Date? You chose the delivery date to be today, This may cause errors in shipping and Freight.
                                        </p>
                                    </div>
                                    
                                    
                                    
                                    
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                 <Button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setBrowse(false)}
                                    className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    Close
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            
            
            
            
            
            <Dialog open={prePayAlert} onClose={setPrePayAlert} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                        <CreditCardIcon aria-hidden="true" className="size-6 text-green-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Pre Pay Alert
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="text-sm opacity-50">
                            You have chosen this order to be a prepay order. This means that this order
                              will receive an additional 3% discount. This order has to be paid in full by
                              <span className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}> February 21st, 2025</span> in order to receive this discount.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={() => setPrePayAlert(false)}
                        className={`inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                      >
                          Continue
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={() => {
                            setPrePay(false);
                            setPrePayAlert(false);
                        }}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        Remove Discount
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
            
            <Dialog open={EODAlert} onClose={setEODAlert} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/20 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 font-mono z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-2xl ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                        <CheckBadgeIcon aria-hidden="true" className="size-6 text-green-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Early Order Alert
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="text-sm opacity-50">
                            You have chosen and Early Order. This means that this order
                              will receive an additional 5% discount. This order has to be placed by
                              <span className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}> February 7th, 2025</span> additionally you must take delivery by
                              <span className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}> Jan 1st</span> -
                              <span className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}> May 1st</span> in order to receive this discount. Payment must be received by
                              <span className={`font-bold ${darkMode ? 'text-white' : 'text-black'}`}> June 1st</span>.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={() => setEODAlert(false)}
                        className={`inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                      >
                          Continue
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={() => {
                            setEarlyOrder(false);
                            setEODAlert(false);
                        }}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        Remove Discount
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>

            
        </div>
    )
};


export default NewOrder;
